import React, { useEffect } from "react";
// reactstrap components
import { Container } from "reactstrap";
// core components
import OnlyHeader from "components/Layout/OnlyHeader.js";

import { useDispatch, useSelector } from "react-redux";

import CheckoutQuestionTable from "components/CheckoutQuestion/CheckoutQuestionTable";
import { getCheckoutQuestion } from "store/actions/checkoutQuestionAction";

const CheckoutQuestion = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getCheckoutQuestion(user?.restaurantID));
  }, [dispatch, user?.restaurantID]);

  return (
    <>
      <OnlyHeader />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <CheckoutQuestionTable />
      </Container>
    </>
  );
};

export default CheckoutQuestion;
